// extracted by mini-css-extract-plugin
export var details = "_l0-0";
export var inspectorPopover = "_l0-1";